import React from 'react';
import classNames from 'classnames';

import { getFormattedAmount } from 'src/utils/helpers';

import style from './ShipmentPriceInfo.module.scss';

const ShipmentPriceInfo = ({ shippingPrice = 15, included, className }) => {
  if (included) {
    return (
      <p className={classNames(style.shippingPrice, className)}>(w tym {getFormattedAmount(shippingPrice)} kosztów wysyłki)</p>
    );
  }

  return (
    <span className={classNames(style.shippingPrice, className)}>
      {shippingPrice === 0 ? 'Darmowa wysyłka' : `(+ koszt wysyłki ${getFormattedAmount(shippingPrice)})`}
    </span>
  );
};

export default ShipmentPriceInfo;
